export function renderPhasenlabels({ target, labels }) {
	if (!target) return

	target.replaceChildren()

	let previousRight = -Infinity

	labels.forEach((labelData) => {
		const element = document.createElement("div")
		element.textContent = labelData.label
		element.style.position = "absolute"
		element.style.left = "0px"
		element.style.bottom = "0px"
		element.style.padding = "0px 0px"
		element.style.color = "#6F7678"
		element.style.fontSize = "12px"
		element.style.fontWeight = "500"
		element.style.whiteSpace = "nowrap"
		element.style.pointerEvents = "none"

		target.append(element)

		const width = element.offsetWidth
		const left = Math.max(labelData.minLeft, Math.min(labelData.left, labelData.maxRight - width))
		if (left < previousRight + 8) {
			element.remove()
			return
		}

		element.style.left = `${left}px`
		previousRight = left + width
	})
}
